import React, { useState } from "react";
import { useStaticQuery, graphql } from "gatsby"
import TraderMapItems from "../blog/trader-map-items"

const Stalls = () => {
    const data = useStaticQuery(graphql`{
        allContentfulTrader (filter: {traderLocationType: {eq: "Stalls"}}) {
                edges {
                    node {
                        traderTitle
                        traderNumber
                        slug
                        id
                        traderCategory
                    }
                }
            }
        }
    `)
    
  return (
    <TraderMapItems items={data} />
  );
};

export default Stalls;

